import dayjs from 'dayjs';
import { useContext, useState } from 'react';

import { useForm } from '@mantine/form';

import { selectPersonId } from '@/store/user-process/user-selectors.ts';

import { AppContext } from '@/contexts/AppContext/AppContextProvider';

import { TODAY } from '@/shared/constant/app';
import useAppStore from '@/shared/store/app.store.ts';
import { useSettingsStore } from '@/shared/store/settings.store.ts';
import useUserStore from '@/shared/store/user.store.ts';
import { TDateRange } from '@/shared/types/app.types';
import { IGuest } from '@/shared/types/booking.types';
import { BookingType } from '@/shared/types/bookingObjects.types';

import { getNearestDate } from '@/utils/date';

import { useAppSelector } from '@/hooks';

export type TParkingPlaceForm = {
	booking_object_id?: number | null;
	client_id: number | undefined;
	date: TDateRange;
	kind: BookingType;
	pass_id: number | null;
	car_number: string;
	is_guest: boolean;
	guests: IGuest[] | [];
};

export const useParkingPlaceForm = () => {
	const { date } = useAppStore();
	const defaultCarNumber = useSettingsStore((state) => state.carNumber);
	const carPasses = useUserStore((state) => state.carPasses);
	const defaultCarPass = carPasses?.find((pass) => pass.value === defaultCarNumber?.value);

	const [isGuest, setIsGuest] = useState(false);
	const [isTaxi, setIsTaxi] = useState(false);
	const personId = useAppSelector(selectPersonId);

	const form = useForm<TParkingPlaceForm>({
		validateInputOnChange: true,
		initialValues: {
			date: [
				(dayjs(date[0]).isToday() ? getNearestDate(TODAY) : dayjs(date[0])).toDate(),
				(dayjs(date[1]).isAfter(TODAY)
					? dayjs(date[1])
					: getNearestDate(TODAY).endOf('day')
				).toDate(),
			],
			client_id: personId,
			booking_object_id: null,
			kind: 'parking_place',
			car_number: defaultCarPass?.label ?? '',
			pass_id: defaultCarPass ? Number(defaultCarPass.value) : null,
			is_guest: false,
			guests: [],
		},
		validate: {
			client_id: (value) => (!value ? 'Invalid client_id' : null),
			booking_object_id: (value) => (!value ? 'Необходимо выбрать локацию' : null),
			car_number:
				isGuest || isTaxi
					? (value) =>
							/[A-Z]\d{3}[A-Z]{2}\d{2,3}/.test(value) ? null : 'Поле не может быть пустым'
					: (value) => (!value ? 'Поле не может быть пустым' : null),
			pass_id: (value) =>
				isGuest || isTaxi || carPasses?.some((pass) => pass.value === String(value))
					? null
					: 'Выберите номер автомобиля',

			...(isGuest
				? {
						guests: {
							full_name: (name) => (!name.trim() ? 'Поле не может быть пустым' : null),
							// email: (email) =>
							// 	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/i.test(email)
							// 		? null
							// 		: 'Указана неверная электронная почта',
							// phone: (phone) =>
							// 	/\+7\(\d{3}\)\d{3}-\d{4}/.test(phone) ? null : 'Указан неверный номер телефона',
						},
					}
				: undefined),
		},
	});

	return { form, isTaxi, setIsTaxi, setIsGuest };
};
